module.exports = __webpack_public_path__ + "quotezone-ui/img/multipoint-white.26783fff.gif";